// @ts-nocheck
import * as actions from './secondaryLeftAreaActions';
import reducer from './secondaryLeftAreaReducer';
import * as selectors from './secondaryLeftAreaSelectors';

export { actions, reducer, selectors };
